import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";
import { formatApiError } from "@/lib/api";
import { CSLogo } from "@/components/CSLogo";

export default function AdminLoginPage() {
  const { login, user } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => { if (user?.role === "admin") navigate("/admin"); }, [user, navigate]);

  const submit = async (e) => {
    e.preventDefault(); setSubmitting(true);
    try { await login(email, password); toast.success("Welcome back"); navigate("/admin"); }
    catch (err) { toast.error(formatApiError(err)); }
    finally { setSubmitting(false); }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#F5F5F5] px-4" data-testid="admin-login-page">
      <div className="w-full max-w-md bg-white rounded-2xl border border-gray-200 p-8">
        <div className="flex justify-center"><CSLogo /></div>
        <h1 className="mt-6 font-display font-extrabold text-2xl text-center text-gray-900">Admin Login</h1>
        <p className="text-center text-sm text-gray-500 mt-1">Carz Swag inventory & lead management</p>
        <form onSubmit={submit} className="mt-6 space-y-4">
          <div>
            <label className="text-xs font-semibold text-gray-700">Email</label>
            <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className="mt-1 w-full rounded-md border border-gray-200 px-3 py-2.5 text-sm" data-testid="admin-email" />
          </div>
          <div>
            <label className="text-xs font-semibold text-gray-700">Password</label>
            <input type="password" required value={password} onChange={(e) => setPassword(e.target.value)} className="mt-1 w-full rounded-md border border-gray-200 px-3 py-2.5 text-sm" data-testid="admin-password" />
          </div>
          <button type="submit" disabled={submitting} className="btn-primary w-full" data-testid="admin-login-submit">
            {submitting ? "Signing in…" : "Sign in"}
          </button>
        </form>
      </div>
    </div>
  );
}
